import React from "react";
import { Button } from "semantic-ui-react";
import { WidgetProps } from "../types";
import Prompt from "../Prompt";
import PillPicker from "../PillPicker";
import Summary, { SummaryField, SummaryPills, Actions } from "../Summary";

/** "Too much and too little" — two free-entry lists, no suggestion pool. */
const TooMuchTooLittle: React.FC<WidgetProps> = ({
  payload,
  update,
  submit,
  submitting,
  finished,
  question,
  currentUser,
}) => {
  const tooMuch: string[] = payload.too_much || [];
  const tooLittle: string[] = payload.too_little || [];

  const set = (key: string) => (next: string[]) =>
    update({ ...payload, [key]: next });

  const complete = tooMuch.length >= 1 && tooLittle.length >= 1;

  if (finished) {
    return (
      <Summary question={question} currentUser={currentUser}>
        <SummaryField label="Too much">
          <SummaryPills values={tooMuch} />
        </SummaryField>
        <SummaryField label="Too little">
          <SummaryPills values={tooLittle} />
        </SummaryField>
      </Summary>
    );
  }

  return (
    <div className="ui form assignment-form">
      <Prompt question={question} currentUser={currentUser} />

      <div className="ix-section">
        <div className="ix-label">Too much</div>
        <PillPicker
          selected={tooMuch}
          onChange={set("too_much")}
          placeholder="Add something you have too much of"
          customOnly
        />
      </div>

      <div className="ix-section">
        <div className="ix-label">Too little</div>
        <PillPicker
          selected={tooLittle}
          onChange={set("too_little")}
          placeholder="Add something you have too little of"
          customOnly
        />
      </div>

      <Actions>
        <Button
          primary
          circular
          className="challenge-submit"
          disabled={!complete || submitting}
          loading={submitting}
          onClick={submit}
        >
          Submit
        </Button>
      </Actions>
    </div>
  );
};

export default TooMuchTooLittle;
